import { getDocumentFormActionButtonsV2 } from '@/components/custom/erp';
import { FormMode } from '@/types/form';

/**
 * Get the title for the form dialog based on form mode and active tab
 */
export const getFormTitle = (formMode: FormMode, activeTab: string) => {
  if (formMode !== 'view') {
    return formMode === 'add' ? 'Mới' : 'Sửa';
  }

  switch (activeTab) {
    case 'info':
      return 'Phiếu nhập hàng bán trả lại';
    case 'history':
      return 'Lịch sử';
    default:
      return 'Phiếu nhập hàng bán trả lại';
  }
};

/**
 * Get the action buttons for the form dialog based on form mode and active tab
 */
export const getFormActionButtons = (
  formMode: FormMode,
  activeTab: string,
  handlers: {
    onAdd?: () => void;
    onEdit?: () => void;
    onDelete?: () => void;
    onCopy?: () => void;
    handleClose: () => void;
  }
) => {
  return getDocumentFormActionButtonsV2(
    formMode,
    activeTab,
    {
      ...handlers,
      onPrint: () => console.log('In')
    },
    { showPrint: true }
  );
};
